import { Injectable, inject } from '@angular/core';
import { BaseQueryRepository } from '@okcargo-apps/shared-infrastructure';
import {
  DocumentMetadataResponse,
  FindFreightForShipperQuery,
  FindFreightForShipperQueryHandler,
  FreightBasicForShipperResponse,
  FreightDetailForShipperResponse,
  SearchDocumentMetadataQuery,
  SearchDocumentMetadataQueryHandler,
  SearchFreightsForShippersQueryHandler,
  SearchInProgressFreightsQuery,
  SearchNotInProgressFreightsQuery,
} from '@okcargo/query-processor';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FreightShipperQueryService {
  private readonly queryRepository = inject(BaseQueryRepository);

  private readonly searchFreightsForShippersQueryHandler: SearchFreightsForShippersQueryHandler;

  private readonly findFreightForShipperQueryHandler: FindFreightForShipperQueryHandler;
  private readonly searchDocumentMetadataQueryHandler: SearchDocumentMetadataQueryHandler;

  constructor() {
    const queryRepository = this.queryRepository;

    this.searchFreightsForShippersQueryHandler = new SearchFreightsForShippersQueryHandler(queryRepository);

    this.findFreightForShipperQueryHandler = new FindFreightForShipperQueryHandler(queryRepository);
    this.searchDocumentMetadataQueryHandler = new SearchDocumentMetadataQueryHandler(queryRepository);
  }

  // TODO first, add query filter here
  // TODO then, refactor this, use only one query, move search criteria to application layer
  searchInProgressFreights(query: SearchInProgressFreightsQuery): Promise<FreightBasicForShipperResponse[]> {
    return this.searchFreightsForShippersQueryHandler
      .handle(query)
      .then((response) => response.items as FreightBasicForShipperResponse[]);
  }

  searchFinishedFreights(query: SearchNotInProgressFreightsQuery): Promise<FreightBasicForShipperResponse[]> {
    return this.searchFreightsForShippersQueryHandler
      .handle(query)
      .then((response) => response.items as FreightBasicForShipperResponse[]);
  }

  findFreight(query: FindFreightForShipperQuery): Observable<FreightDetailForShipperResponse> {
    return from(this.findFreightForShipperQueryHandler.handle(query));
  }

  searchDocumentMetadata(query: SearchDocumentMetadataQuery): Promise<DocumentMetadataResponse[]> {
    return this.searchDocumentMetadataQueryHandler.handle(query);
  }
}
